<script>
import Hotkey from 'dashboard/components/base/Hotkey.vue';

export default {
  components: {
    Hotkey,
  },
  data() {
    return {
      ctrlKey: 'Ctrl',
      keyShortcuts: [
        {
          key: 'K',
          description: this.$t('CONVERSATION.EMPTY_STATE.CMD_BAR'),
        },
        {
          key: '/',
          description: this.$t('CONVERSATION.EMPTY_STATE.KEYBOARD_SHORTCUTS'),
        },
      ],
    };
  },
};
</script>

<template>
  <div class="flex flex-col gap-3">
    <div
      v-for="keyShortcut in keyShortcuts"
      :key="keyShortcut.key"
      class="flex items-center gap-2"
    >
      <div class="flex items-center gap-2">
        <Hotkey
          custom-class="bg-n-button-neutral-bg text-n-button-neutral-text rounded-3xl px-2 py-1 text-xs font-medium"
        >
          {{ ctrlKey }}
        </Hotkey>
        <Hotkey
          custom-class="bg-n-button-neutral-bg text-n-button-neutral-text rounded-3xl px-2 py-1 text-xs font-medium"
        >
          {{ keyShortcut.key }}
        </Hotkey>
      </div>
      <span class="text-sm text-n-slate-11">
        {{ keyShortcut.description }}
      </span>
    </div>
  </div>
</template>
